/** 
  All of the routes for the Material Kit 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Navbar.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `name` key is used for the name of the route on the Navbar.
  2. The `icon` key is used for the icon of the route on the Navbar.
  3. The `collapse` key is used for making a collapsible item on the Navbar that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  4. The `route` key is used to store the route location which is used for the react router.
  5. The `href` key is used to store the external links location.
  6. The `component` key is used to store the component of its route.
  7. The `dropdown` key is used to define that the item should open a dropdown for its collapse items .
  8. The `description` key is used to define the description of
          a route under its name.
  9. The `columns` key is used to define that how the content should look inside the dropdown menu as columns,
          you can set the columns amount based on this key.
  10. The `rowsPerColumn` key is used to define that how many rows should be in a column.
*/

import AboutUs from 'csdd_pages/AboutUs';
import Homepage from 'csdd_pages/Homepage';
import ExecutiveMembers from 'csdd_pages/ExecutiveMembers';
import ContactUs from 'csdd_pages/ContactUs';
import OurPartners from 'csdd_pages/OurPartners';
import News from 'csdd_pages/News';
import Events from 'csdd_pages/Events';
import Gallery from 'csdd_pages/Gallery';
import IndustryUpdates from 'csdd_pages/IndustryUpdates';

const routes = [
  {
    name: 'home',
    component: <Homepage />,
    dropdown: false,
    route: '/',
  },
  {
    name: 'about us',
    collapse: [
      {
        name: 'who we are',
        description: 'Get to know us',
        component: <AboutUs />,
        route: '/about-us',
      },
      {
        name: 'leadership',
        description: 'Learn more about the executive members',
        component: <ExecutiveMembers />,
        route: '/leadership',
      },
      {
        name: 'Partners',
        description: 'See all our partners',
        component: <OurPartners />,
        route: '/partners',
      },
      {
        name: 'contact us',
        description: 'Send us a message',
        component: <ContactUs />,
        route: '/contact-us',
      },
    ],
  },
  {
    name: 'news',
    collapse: [
      {
        name: 'latest news',
        route: '/news',
        component: <News />,
      },
      {
        name: 'industry updates',
        route: '/industry-updates',
        component: <IndustryUpdates />,
      },
    ],
  },
  {
    name: 'events & gallery',
    collapse: [
      {
        name: 'events',
        route: '/events',
        component: <Events />,
      },
      {
        name: 'photo gallery',
        route: '/gallery',
        component: <Gallery />,
      },
    ],
  },
];

export default routes;
